module.exports = __webpack_public_path__ + "static/media/fbicon.8f5ce275.png";